import { useEffect } from 'react';

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

/**
 * Per-route document title and description. This is a client-rendered app, so
 * these run after hydration — crawlers that execute JS pick them up, and the
 * defaults in index.html cover those that do not.
 */
export default function usePageMeta({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', 'content', title);
      setMeta('meta[name="twitter:title"]', 'content', title);
    }
    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
      setMeta('meta[name="twitter:description"]', 'content', description);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', window.location.origin + window.location.pathname);
  }, [title, description]);
}
